import { render } from "./PayoutDetailsModal.vue?vue&type=template&id=c19bb97e"
import script from "./PayoutDetailsModal.vue?vue&type=script&lang=js"
export * from "./PayoutDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__